<header class="login">
    <span [ngClass]="{'isOnline': !helperService.isWebServiceAvailable()}">Mobile</span>
    <span class="spacer"></span>
    <span>{{ vinavonVersion }}</span>
</header>
<main class="login no-footer">
    <div class="container">
        <mat-card appearance="outlined">
            <mat-card-content>
                <h3 class="title">{{ 'MAIN_APP_LOGIN.SIGN_IN' | translate }}</h3>
                <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
                    <mat-form-field>
                        <input matInput placeholder="Benutzername" formControlName="username" required autocomplete="username">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="Passwort" type="password" formControlName="password" required autocomplete="current-password">
                    </mat-form-field>

                    <button mat-stroked-button class="btn-block">Anmelden</button>
                    <mat-error class="error" #errorMessageBox>{{
                            ((errorMessage$ | async) || '') | translate
                        }}
                    </mat-error>
                </form>
            </mat-card-content>
        </mat-card>

        <img alt="Swiss Soft Solutions GmbH" src="assets/images/logo_mobile.png" style="width: 250px; margin: 0 auto;">
    </div>
</main>
